(function(jQuery) {
    'use strict';
    function CollapsibleSectionsJs() {
        var fn = {
            init: function() {
                // Add click listeners
                jQuery(
                    '.collapsible-section .section-header,\
                    .collapsible-section .collapsible-section__close-btn'
                ).click(fn.toggleSection);

                if (window.paPageInfo && (window.paPageInfo.type === 'Product' || window.paPageInfo.type === 'Product Fixed Dates')) {
                    fn.productPageMergeSections();
                }
            },

            toggleSection: function() {
                var jqThis = jQuery(this);
                var jqCurrentSection = jqThis.parents('.collapsible-section');
                var jqHeader = jqCurrentSection.find('.section-header');
                var headerViewportOffsetY =
                    jqHeader.offset().top - jQuery(document).scrollTop();

                fn.toggleCurrentSection(jqCurrentSection, jqHeader);
                fn.closeSiblingSections(
                    jqCurrentSection,
                    jqHeader,
                    headerViewportOffsetY
                );

                jqCurrentSection
                    .siblings('.collapsible-section--open')
                    .removeClass('collapsible-section--open')
                    .addClass('collapsible-section--closed');
            },

            toggleCurrentSection(jqCurrentSection, jqHeader) {
                jqCurrentSection
                    .find('.collapsible-section__content')
                    .slideToggle({
                        step: function() {
                            var headerOffsetTop = jqHeader.offset().top;
                            var scrollTop = jQuery(document).scrollTop();
                            var stickyMenuHeight =
                                jQuery('.main-header').outerHeight() +
                                jQuery('.info-bar').outerHeight();
                            if (
                                headerOffsetTop <
                                scrollTop + stickyMenuHeight
                            ) {
                                // If we have here, we have lost the current section title off the top of the page
                                // This can happen when pressing the "read less" button on a long section
                                jQuery('html, body').scrollTop(
                                    headerOffsetTop - stickyMenuHeight - 50
                                ); // scroll back into view
                            }
                        },
                        complete: function () {
                            var isSectionOpen = jqHeader.parents('.collapsible-section--open').length > 0;
                            var isMap = jqHeader.parents('.TypeMap').length > 0;
                            if (isSectionOpen && isMap) {
                                jQuery(window).trigger('paOpenSection');
                            }
                        }
                    })
                    .parents('.collapsible-section')
                    .toggleClass(
                        'collapsible-section--open collapsible-section--closed'
                    );
            },

            closeSiblingSections(
                jqCurrentSection,
                jqHeader,
                headerViewportOffsetY
            ) {
                // close all open siblings
                jqCurrentSection
                    .siblings('.collapsible-section--open')
                    .find('.collapsible-section__content')
                    .slideUp({
                        step: function() {
                            // retain scroll position while elements above are collapsing
                            var headerOffsetTop = jqHeader.offset().top;
                            jQuery('html, body').scrollTop(
                                headerOffsetTop - headerViewportOffsetY
                            );
                        },
                    });
            },

            mergeSections: function (jqParent, jqSection) {
                var jqCollapsibleContentWrapper = jQuery(
                    '<div class="collapsible-section__content"></div>'
                );
                jqCollapsibleContentWrapper.append(jqSection);
                jqParent
                    .find('.collapsible-section__footer')
                    .before(jqCollapsibleContentWrapper);
                
                jqSection.find('.collapsible-section__hr').remove();
                jqSection.find('.collapsible-section__toggle-btn').remove();
                jqSection.find('.collapsible-section__footer').remove();
            },

            productPageMergeSections: function() {
                var jqParent = jQuery('.classSafetyAndStaffSupport');
                var jqSection = jQuery('.TypeTeam');
                fn.mergeSections(jqParent, jqSection);

                jqParent = jQuery('.classWhatWillIDoOnThisProjectIntro');
                jqSection = jQuery('.classWhatWillIDoOnThisProjectMain');
                fn.mergeSections(jqParent, jqSection);

                jqParent = jQuery('.classWhatWillIDoOnThisProjectIntro');
                jqSection = jQuery('.TypePartners');
                fn.mergeSections(jqParent, jqSection);

                jqParent = jQuery('.classWhatWillIDoOnThisProjectIntro');
                jqSection = jQuery('.TypeItinerary');
                fn.mergeSections(jqParent, jqSection);

                jqParent = jQuery('.classIsThisProjectRightForMe');
                jqSection = jQuery('.classHowItWorks');
                fn.mergeSections(jqParent, jqSection);

                // remove orphaned background wrappers
                jQuery('.Bkg:not(:has(*))').remove();
                jQuery('.collapsible-section-none:not(:has(*))').remove();
            },
        };

        fn.init();
    }
    new CollapsibleSectionsJs();
})($);
